module.exports = __webpack_public_path__ + "static/media/allalerts_unread.2fb5936b.svg";